import { Component, OnInit,EventEmitter } from '@angular/core';
import { Router } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-sainik-sidenav',
  templateUrl: './sainik-sidenav.component.html',
  styleUrls: ['./sainik-sidenav.component.css']
})
export class SainikSidenavComponent implements OnInit {
  // change: any;
  // router: any;
  menuList:any;
  pageList:any;

  constructor(private router: Router) { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Utilities')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

  Logout(){

    localStorage.clear();
    // this.change.emit(true);
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/sainik-sidenav/sainik-sidenav.component.ts